import { httpClient } from '@/network/clientController'

/** Gets Operations Approvals list
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_operationssigned
*/
export const getOperationApprovalsList = payload => {
	return httpClient({
		method: 'GET',
		url: 'operations/signed',
		params: payload,
		isCancellable: true
	})
}

/** Gets Accounts With operations peding signature
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_operationssignedaccounts
*/
export const getAccountsWithOperationsPendingSignature = payload => {
	return httpClient({
		method: 'GET',
		url: 'operations/signed/accounts',
		params: payload,
		isCancellable: true
	})
}

/** Remove Signature from operation
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/DELETE_operationssignedsignature
*/
export const removeSignatureFromOperation = payload => {
	return httpClient({
		method: 'DELETE',
		url: 'operations/signed/signature',
		params: payload
	})
}

/** Sign multiple operations
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/POST_operationssignedsignatures
*/
export const signMultipleOperations = payload => {
	return httpClient({
		method: 'POST',
		url: 'operations/signed/signatures',
		data: payload,
		operationTypeId: 303 /* for mocks handling of tokens */
	})
}
